var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: "value", width: 1000, "max-width": 1000 },
      on: { "click:outside": _vm.closeSplash }
    },
    [
      _c(
        "v-card",
        { attrs: { tile: "", elevated: "" } },
        [
          _c(
            "v-toolbar",
            { staticClass: "mb-4", attrs: { elevated: "", color: "primary" } },
            [
              _c(
                "v-toolbar-title",
                [
                  _c("v-card-title", { staticClass: "white--text" }, [
                    _vm._v(
                      "\n          Welcome to the Item Master Portal\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-subtitle",
                    { staticClass: "grey--text text--lighten-4" },
                    [
                      _vm._v(
                        "\n          You can use the filters menu above to locate items using one or more search criteria.\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-img", {
            staticClass: "mx-auto",
            attrs: {
              src: require("@/assets/splash-gif.gif"),
              alt: "Splash page gif",
              width: 800
            }
          }),
          _vm._v(" "),
          _c("v-card-text", {
            staticClass: "black--text",
            domProps: { innerHTML: _vm._s(_vm.copyText) }
          }),
          _vm._v(" "),
          _c(
            "v-toolbar",
            { attrs: { flat: "", color: "toolbar" } },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { color: "primary" }, on: { click: _vm.closeSplash } },
                [_vm._v("Close")]
              ),
              _vm._v(" "),
              _c("v-spacer")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e2b291b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e2b291b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/items/itemMasterSplash.vue
// module id = null
// module chunks = 